var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{class:['md-card-timeline', {'md-card-plain': _vm.plain}]},[_c('ul',{class:['timeline', {'timeline-simple': _vm.type === 'simple'}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }